<template lang="pug">
v-container
    v-layout(row wrap)
        v-flex(xs12)
            v-card.transparent(dark flat)
                v-card-text.text-center
                    h2.pt-10.display-2.white--text RC IVA
                    h3.font-weight-regular Regimen Complementario Impuesto al Valor Agregado
                v-card-text.no-padding
                    v-layout(row wrap)
                        v-flex(xs12 md6)
                            h3.display-1.font-weight-light.white--text.pb-1 Información:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding
                                p.subtitle-1(style="line-height:22px;text-align:justify;").no-margin.pt-2 El Régimen Complementario al Impuesto al Valor Agregado (RC-IVA) es un tributo que se aplica a empleados del sector público o privado que reciben un salario mensual. Este tributo busca controlar que todas las personas exijan su factura o nota fiscal por el consumo de bienes y servicios.<br>
                                p.subtitle-1(style="line-height:22px;text-align:justify;").mt-2
                                    | <i>"Los trabajadores cuyo sueldo superen los cuatro salarios mínimos nacionales <strong style="color:#FFF">(Bs. 8488)</strong> deben descargar con facturas dependiendo el monto ganado el cual puede calcularse desde <a href="https://form.jotform.com/81274441091957" style="color:#FFF" target="blank">aquí</a>".</i>
                            h3.display-1.font-weight-light.white--text.pb-1 Requisitos:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding.mt-4
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 1er. Juego Ministerio de eduación
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario 110, del Servicio de Impuestos Nacionales(SIN) impreso(Original) llenado via software <a href="http://www.impuestosbolivia.net/form4/facilito.php" target="blank" style="color:#FFF">Facilito</a>.<br>
                                    | - Medio magnético(CD) adjuntado el archivo .dec generado por el software facilito.<br>
                                    | - Facturas emitidas en no mas de 120 días antes de la fecha de presentación del formulario.(Originales)<br>
                                    | - Última boleta de pago (fotocopia nítida).
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 2do. Juego Dirección departamental
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario 110, del Servicio de Impuestos Nacionales(SIN) impreso(Original) llenado via software <a href="http://www.impuestosbolivia.net/form4/facilito.php" target="blank" style="color:#FFF">Facilito</a>.<br>
                                    | - Medio magnético(CD) adjuntado el archivo .dec generado por el software facilito.<br>
                                    | - Facturas emitidas en no mas de 120 días antes de la fecha de presentación del formulario.(Fotocopias)<br>
                                p.subtitle-1.white--text(style="line-height:22px;").no-margin 3er. Juego Dirección distrital
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - Formulario 110, del Servicio de Impuestos Nacionales(SIN) impreso(Original) llenado via software <a href="http://www.impuestosbolivia.net/form4/facilito.php" target="blank" style="color:#FFF">Facilito</a>.<br>
                            h3.display-1.font-weight-light.white--text.pb-1 Notas:
                            v-divider.success
                            v-divider.success
                            v-flex(xs12).no-padding.mt-4
                                p.subtitle-1.pl-5(style="line-height:22px;text-align:justify;")
                                    | - La documentación requerida debe ser presentada en el distrito al cual el docente pertenece ya que el técnico validará esta información antes de recepcionar sus documentos.<br>
                                    | - La presentación de descargos con formularios 110 se debe realizar un mes antes del periodo (mes) al que pertenece el formulario. osease que si el formulario 110 pertenece al periodo mes de junio, se debe presentar hasta el 22 de junio en dirección distrital al que pertenece el docente.
                        v-flex(xs12 md5 offset-md-1)
                            h3.display-1.font-weight-light.white--text.text-center Medio magnético:
                            c-form-subir-archivo-dec
            v-dialog(v-model="dialogConfirm" width=400)
                v-card
                    v-toolbar(dark color="success" dense).no-padding.no-margin
                        v-toolbar-title Archivo subido.
                        v-spacer
                        v-btn(icon dark @click="dialogConfirm = false")
                            v-icon fas fa-times
                    v-card-text.text-center.pb-5
                        h3.pt-3 Su archivo fué subido correctamente al servidor, puede verificarlo mas adelante con su ci:
                        h3.pt-2 4687156
                        v-btn(color="success" @click="dialogConfirm = false").mt-2 Aceptar
            v-dialog(v-model="dialogUltimosDec" width=600 scrollable)
                v-card
                    v-toolbar(dar color="success" dense dark).no-padding.no-margin
                        v-toolbar-title Últimos archivos (.dec) subidos por: 4434655
                        v-spacer
                        v-btn(icon dark @click="dialogUltimosDec = false")
                            v-icon fas fa-times
                    v-card-text.no-padding(style="height:305px")
                        v-data-table(:headers="headers" :items="desserts" disable-pagination hide-default-footer)
                            template(v-slot:item.estado="{ item }")
                                v-chip(color="green" dark) {{ item.estado }}
                                    v-icon(right small) fas fa-check
</template>
<script>
export default {
    data() {
        return {
            dialogConfirm: false,
            dialogUltimosDec: false,
            isLoading: false,
            headers: [
                { text: 'CI:', align: 'center', value: 'ci' },
                { text: 'Periodo (MES):', align: 'center',value: 'mes' },
                { text: 'Periodo (AÑO)', align: 'center',value: 'gestion' },
                { text: 'Fecha de presentación', align: 'center',value: 'fechaPresentacion' },
                { text: 'Estado', align: 'center',value: 'estado' }
            ],
            desserts: [
                {
                    ci: '4434655',
                    fechaPresentacion: '22/01/2019',
                    mes: 'enero',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '20/02/2019',
                    mes: 'febrero',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '19/03/2019',
                    mes: 'marzo',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '22/04/2019',
                    mes: 'abril',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '19/05/2019',
                    mes: 'mayo',
                    gestion: 2019,
                    estado: 'Presentado'
                },
                {
                    ci: '4434655',
                    fechaPresentacion: '02/06/2019',
                    mes: 'enero',
                    gestion: 2019,
                    estado: 'Presentado'
                }
            ]
        }
    },
    methods: {
        subirArchivoDec(){
            //this.isLoading = true
            this.dialogConfirm = true
            this.$snotify.success('Archivo subido correctamente.',{timeout:15000})
        }
    }
}
</script>